module.exports = __webpack_public_path__ + "static/media/cclogo.06938533.png";